import React from 'react'
import './Hero.css'
import Header from './Header/Header'
import hero_image from "../assets/hero_image.png"
import hero_image_back from "../assets/hero_image_back.png"
import Heart from "../assets/heart.png"
import Calories from "../assets/calories.png"
import {motion} from 'framer-motion'
import NumberCounter from 'number-counter'
import { Link } from 'react-scroll'

const Hero = () => {
  const transition = {type: 'spring', duration: 1.5}
  const mobile = window.innerWidth <= 768 ? true : false;

  return (
    <div className="hero" id='home'>
      <div className='blur hero-blur'></div>
      <div className="left-h">
        <Header/>
        
        {/* AD */}
        <div className='ad'>
          <motion.div
            initial={{left: mobile ? "165px" : '270px'}}
            whileInView={{left: '10px'}}
            transition={{...transition, type: 'tween'}}
          ></motion.div>
          <span>The Best Fitness Journey Begins Here</span>
        </div>

        {/* Heading Hero */}
        <div className="hero-text">
          <div>
            <span className='stroke-text'>SHAPE</span>
            <span> YOUR</span>
          </div>
          <div>
            <span>IDEAL BODY</span>
          </div>
          <div>
            <span>
              IN HERE WE WILL HELP YOU TO SHAPE AND BUILD YOUR IDEAL BODY AND LIVE UP YOUR LIFE TO FULLEST
            </span>
          </div>
        </div>

        {/* Figures + Calories Row */}
        <div className="stats-row">
          <div className="figures">
            <div>
              <span>+
                <NumberCounter end={140} start={100} delay={4} prefix="+" />
              </span>
              <span>expert coaches</span>
            </div>
            <div>
              <span>+
                <NumberCounter end={978} start={800} delay='4' prefix="+"/>
              </span>
              <span>members joined</span>
            </div>
            <div>
              <span>+
                <NumberCounter end={50} start={40} delay='4' prefix="+"/>
              </span>
              <span>fitness programs</span>
            </div>
          </div>

          <motion.div 
            initial={{right: '37rem'}}
            whileInView={{right: '28rem'}}
            transition={transition}
            className="calories">
            <img src={Calories} alt="" />
            <div>
              <span>Calories Burned</span>
              <span>220 kcal</span>
            </div>
          </motion.div>
        </div>

        {/* Hero Buttons */}
        <div className="hero-buttons">
          <Link to="plans" smooth={true} style={{textDecoration: 'none'}}>
            <button className="btn">Get Started</button>
          </Link>
          <Link to="join-us" smooth={true} style={{textDecoration: 'none'}}>
            <button className="btn">Learn More</button>
          </Link>
        </div>
      </div>

      {/* Right Section - Join Now button position fixed */}
      <div className="right">
        {/* Join Now button with original positioning */}
        <Link 
          to="join-us" 
          smooth={true} 
          style={{
            position: 'absolute',
            right: '3rem',
            top: '2rem',
            zIndex: 2,
            textDecoration: 'none'
          }}
        >
          <button className="btn" style={{
            color: 'red',
            backgroundColor: 'white',
            width: 'fit-content',
            padding: '1rem',
            marginRight:'2rem',
            left:'5rem',
            borderRadius: '5px'
          }}>
            Join Now
          </button>
        </Link>

        {/* Rest of right section remains unchanged */}
        <motion.div 
          initial={{right: "-2rem"}}
          whileInView={{right: "5rem"}}
          transition={transition}
          className="heart-rate">
          <img src={Heart} alt="" />
          <span>Heart Rate</span>
          <span>116 bpm</span>
        </motion.div>
        
        <img src={hero_image} alt="" className='hero-image' />
        <motion.img 
          initial={{right: '11rem'}}
          whileInView={{right: '20rem'}}
          transition={transition}
          src={hero_image_back} alt="" className='hero-image-back'/>
      </div>
    </div>
  )
}

export default Hero